import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=2177e6e1&scoped=true"
import script from "./prize.vue?vue&type=script&lang=js"
export * from "./prize.vue?vue&type=script&lang=js"
import style0 from "./prize.vue?vue&type=style&index=0&id=2177e6e1&prod&lang=stylus&scoped=true"
import style1 from "./prize.vue?vue&type=style&index=1&id=2177e6e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2177e6e1",
  null
  
)

export default component.exports